import * as HttpService from './http.service';
import {
    GET_IRS_CTA,
    GET_IRS_CTA_BY_CCY,
    GET_FOREX_CTA_BY_PAIR,
    GET_FOREX_CTA_TICKERS,
    GET_EQUITY_CTA_BY_TICKERS
} from './url.service';

export const getIrsCta = (data) => HttpService.getWithAuth(GET_IRS_CTA(data));
export const getIrsCtaByCcy = (params) => HttpService.getWithAuth(GET_IRS_CTA_BY_CCY(params));
export const getForexCtaByPair = (params) => HttpService.getWithAuth(GET_FOREX_CTA_BY_PAIR(params));
export const getForexCtaTickers = () => HttpService.getWithAuth(GET_FOREX_CTA_TICKERS());
export const getEquityCtaByTickers = (params) => HttpService.getWithAuth(GET_EQUITY_CTA_BY_TICKERS(params));
